import dynamic from 'next/dynamic'

export const BentoRectangleTestimonial = dynamic(
    () => import('./bento-rectangle-testimonial'),
)
